import { render, staticRenderFns } from "./InterpretationRevalidationPendingForm.vue?vue&type=template&id=9790b2a0&"
import script from "./InterpretationRevalidationPendingForm.vue?vue&type=script&lang=js&"
export * from "./InterpretationRevalidationPendingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports